<template>
    <div class="content-widget">
        <iframe
            class="iframe-content"
            title="iframe-widget"
            :class="{'solen-content': widgetId === 'sunshine'}"
            :src="url"
            frameBorder="0"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'IframeWidget',
        data() {
            return {
                hiddenSidebarWidgets: [
                    'cityscan'
                ]
            }
        },
        props: [
            'widgetId',
            'url'
        ],
        mounted() {
            if (this.hiddenSidebarWidgets.includes(this.$props.widgetId))
                EventBus.$emit('toggleSidebar');
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/main.scss";
    @import "@/assets/scss/components/_sidebar.scss";

    .iframe-content{
        width: 100%;
        height: 100%;
        &.solen-content{
            height: 95vh;
            margin-top: 55px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/IframeWidget.vue